import React from "react";
import { Empty, Spin } from "antd";
import { Link } from "react-router-dom";

interface NoAssetsProps {
    loading?: boolean;
}

const NoAssets: React.FC<NoAssetsProps> = ({ loading = false }) => {
    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 240 }}>
                <Spin tip="Loading" />
            </div>
        );
    }

    return (
        <Empty
            description={
                <div>
                    <div>
                        You don't have any assets configured yet. <Link to="/assets">Click here</Link> to add some.
                    </div>
                    <div>We will contact you as soon as possible to get you started.</div>
                </div>
            }
        ></Empty>
    );
};

export default NoAssets;
